import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const BASE_URL = getBaseUrl('/automationConditionTemplates/');

export async function getConditionTemplates() {
    return appRequest.doGetRequest(BASE_URL);
}

export async function saveConditionTemplate(template) {
    return appRequest.doPostRequest(BASE_URL, template);
}

export async function deleteConditionTemplate(id) {
    return appRequest.doDeleteRequest(`${BASE_URL}${id}`);
}
